import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Icon } from '..';
import {
    breakpoints,
    colors,
    fontSizes,
    fontWeights,
    gutterSizes,
    lineHeights,
    mediaQuery,
    boxSizes,
} from '../base/theme';

export const Wrapper = styled.article`
    position: relative;
    background-color: ${colors.white};
    border-radius: ${boxSizes.borderRadius8};
    overflow: hidden;
    box-shadow: 0 0 12px 0 rgb(0 0 0 / 20%);
`;

export const A = styled.a`
    display: block;
    box-sizing: border-box;
    width: 100%;
    padding: 16px;
`;

export const AContentWrapper = styled('div')`
    width: 100%;
    display: flex;
`;

export const ContentWrapper = styled('div')`
    flex-grow: 1;
    margin-left: 16px;
    // overflow: hidden;
    position: relative;
`;

export const TopTagWrapper = styled.div`
    width: 100%;
    padding: 2px 0 16px;
    position: relative;
    
    display: flex;
    justify-content: flex-start;
`;

export const FavouriteWrapper = styled('div')`
    width: 24px;
    height: 24px;
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 1;
`;

export const ImageScoreWrapper = styled.div`
    width: 100%;
    flex-basis: 112px;
    flex-shrink: 0;
`;

export const ImageWrapper = styled.div`
    width: 100%;
    min-height: 112px;
    position: relative;
    flex-basis: 112px;
    flex-shrink: 0;
`;

export const ImageBadge = styled.div<{
    isUrgent?: boolean;
    isFeatured?: boolean;
    isJobsCategory?: boolean;
    isNewUiForCategory?: boolean;
}>`
    border-radius: 50px;
    color: ${colors.white};
    display: flex;
    align-items: center;
    line-height: 20px;
    font-size: ${fontSizes.small};
    font-weight: ${fontWeights.bold};
    padding: ${gutterSizes.xsmall} ${gutterSizes.base};
    margin-right: 8px;

    ${({ isUrgent, isNewUiForCategory }) => isUrgent && `background: ${isNewUiForCategory ? '#419F08' : colors.red};`};
    ${({ isFeatured }) => isFeatured && `background: ${colors.blue};`};
`;

export const ImageCounterLabelStyle = css`
    background: rgba(0, 0, 0, 0.5);
    color: ${colors.white};
    font-size: ${fontSizes.small};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 ${gutterSizes.base};
    margin-right: ${gutterSizes.small};
    border-radius: ${boxSizes.borderRadius4};

    ${Icon} {
        padding-right: ${gutterSizes.small};
    }
`;

export const H2 = styled.div<{
    isShowFavourite?: boolean;
    isGridView?: boolean;
    isForSaleCategory?: boolean;
}>`
    font-size: ${fontSizes.base};
    font-weight: ${fontWeights.bold};
    line-height: ${lineHeights.medium};
    margin-right: 6px;
    margin-bottom: 6px;
    display: -webkit-box;
    word-break: break-all;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;

    ${({ isShowFavourite }) => isShowFavourite && ` margin-right: 30px;`};

    ${mediaQuery.until(breakpoints.medium)} {
        -webkit-line-clamp: 2;
    }
`;

export const SecondWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    /* align-items: center; */

    ${mediaQuery.until(breakpoints.medium)} {
        flex-direction: column-reverse;
    }
`

export const CateName = styled.div`
    height: 20px;
    font-size: ${fontSizes.base};
    font-weight: ${fontWeights.normal};
    line-height: ${lineHeights.small};
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: 4px;

    ${mediaQuery.from(breakpoints.medium)} {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 0;
        &::before {
            content: '';
            display: block;
            height: 4px;
            width: 4px;
            border-radius: 50%;
            background-color: ${colors.bark05};
            margin: 0 8px;
        }
    }
`

export const LocationWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;

    ${mediaQuery.until(breakpoints.medium)} {
        align-items: start;

        .icon--location {
            margin-top: 2px;
        }
    }
`;

export const LocationName = styled.div`
    margin-left: 4px;
    font-size: ${fontSizes.base};
    font-weight: ${fontWeights.normal};
    line-height: ${lineHeights.small};
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;


    ${mediaQuery.until(breakpoints.medium)} {
        -webkit-line-clamp: 2;
    }
`;

export const InfoWrapper = styled.div`
    width: 100%;

    ${mediaQuery.from(breakpoints.medium)} {
        display: flex;
        justify-content: space-between;
        margin-top: 16px;
    }
    ${mediaQuery.until(breakpoints.medium)} {
        margin-top: 24px;
    }
`;

export const Skills = styled.div`
    overflow: hidden;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;

    ${mediaQuery.until(breakpoints.medium)} {
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
        & > div {
            width: 47%;
        }
    }
`;

export const SkillItem = styled.div`
    width: 100%;
    flex-shrink: 0;
    flex-grow: 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    color: ${colors.newDarkGrey};
    margin-top: 8px;

    ${mediaQuery.until(breakpoints.medium)} {
        width: 47%;
    }
`;
export const SkillItemDesc = styled.div`
    margin-left: 4px;
    font-size: ${fontSizes.small};
    font-weight: ${fontWeights.normal};
    line-height: ${lineHeights.xsmall};
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
`;

export const CtaWrapper = styled.div`
    flex-shrink: 0;
    /* flex-basis: 194px;
    width: 194px; */
    flex-basis: 224px;
    width: 224px;

    display: flex;
    flex-flow: column-reverse;
    
    ${mediaQuery.until(breakpoints.medium)} {
        width: 100%;
        margin-top: 16px;
    }
`;
